export default "__VITE_ASSET__cc21a86a__"